<template>
  <transition name="fade">
    <div
      class="loading_container text-xs-center"
      style=" position: fixed;
        width: 500px;
        height: 200px;
        top: 50%;
        left: 50%;
        margin-top: -100px;
        margin-left: -250px;
        z-index: 500;
       "
      v-if="isLoading"
    >
      <div style="display: block;">
        <div class="spinner-walk loading_container text-xs-center">
          <img src="/static/img/assets/loading/z-walk.png" alt="loading" />
        </div>
      </div>
      <!-- <div
        class="loader-walk"
        style="position: absolute;
    background-size: 100px;
    background-attachment: fixed;"
      ></div> -->
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function() {
    return {
      // isLoading : true
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading'
    })
  }
}
</script>

<style>
.loading_container {
  /* position: fixed; */
  /* z-index: 30; */
  /* height: 2em; */
  /* margin: auto; */
  /* top: 0;
  left: 0;
  bottom: 0;
  right: 0; */
}

.loading_container:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/loading.vue